import { PropertyPaymentsScreen } from '@/modules/payments';
import PropertyPaymentsScreenWeb from '@/modules/payments/PropertyPaymentsScreenWeb';
import { Platform } from 'react-native';

export default function PropertyPaymentsRoute() {
    if (Platform.OS === 'web') {
        return <PropertyPaymentsScreenWeb />;
    }
    return <PropertyPaymentsScreen />;
}

